import { render, staticRenderFns } from "./ActionImprovementProblemEdit.vue?vue&type=template&id=516439c1"
import script from "./ActionImprovementProblemEdit.vue?vue&type=script&lang=js"
export * from "./ActionImprovementProblemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports